var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthernet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H6H7H10H17H18H19C20.6569 19 22 17.6569 22 16V8C22 6.34315 20.6569 5 19 5H5ZM18 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7H5C4.44772 7 4 7.44772 4 8V16C4 16.5523 4.44772 17 5 17H6V15V12C6 10.8954 6.89543 10 8 10H9.08535C9.29127 9.4174 9.84689 9 10.5 9H13.5C14.1531 9 14.7087 9.4174 14.9146 10H16C17.1046 10 18 10.8954 18 12V15V17ZM8 17H9V15C9 14.4477 9.44772 14 10 14C10.5523 14 11 14.4477 11 15V17H13V15C13 14.4477 13.4477 14 14 14C14.5523 14 15 14.4477 15 15V17H16V15V12H14.5C13.8469 12 13.2913 11.5826 13.0854 11H10.9146C10.7087 11.5826 10.1531 12 9.5 12H8V15V17Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernet);
export default __webpack_public_path__ + "static/media/ethernet.431946341a2a2871343463c1ba718e55.svg";
export { ForwardRef as ReactComponent };